import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {HeaderService} from '../../../core/services/header.service';
import {ReportsService} from '../../reports.service';
import {merge} from 'rxjs';
import {MatPaginator} from '@angular/material/paginator';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import {tap} from 'rxjs/operators';
import {MatDialog} from '@angular/material/dialog';
import {MatExportDialogComponent} from '../../../dialogs/mat-export/mat-export-dialog.component';
import {ReportsService as UsersReportsApiService} from '../../../api/services/reports.service';
import {ExportFieldModel} from '../../../api/models/export-field-model';
import {UsersSummaryService} from '../users-summary.service';
import {UsersSummaryDatasource} from './users-summary.datasource';
import {UsersSummaryModel} from '../../../api/models/users-summary-model';
import {UsersSummaryFilterRequest} from '../../../api/models/users-summary-filter-request';
import {CallLogsDialogComponent} from '../../call-logs/call-logs-dialog.component';
import { FlexModule } from '@angular/flex-layout';
import { NgIf, AsyncPipe } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatMiniFabButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-users-summary-grid',
    templateUrl: './users-summary-grid.component.html',
    styleUrls: ['./users-summary-grid.component.scss'],
    standalone: true,
    imports: [
        FlexModule,
        NgIf,
        MatProgressSpinner,
        MatTable,
        MatSort,
        MatColumnDef,
        MatHeaderCellDef,
        MatHeaderCell,
        MatSortHeader,
        MatCellDef,
        MatCell,
        MatMiniFabButton,
        MatTooltip,
        MatIcon,
        MatHeaderRowDef,
        MatHeaderRow,
        MatRowDef,
        MatRow,
        MatPaginator,
        AsyncPipe,
    ],
})
export class UsersSummaryGridComponent implements OnDestroy, OnInit, OnChanges {

  displayedColumns: string[] = [
    '_id',
    'name',
    'totalCount',
    'totalOutgoingCount',
    'totalOutgoingAnswered',
    'totalIncomingCount',
    'totalIncomingAnswered',
    'totalIncomingMailbox',
    'totalIncomingMissed',
    'totalInternalCount',
    'totalInternalAnswered',
    'totalInternalMailbox',
    'totalInternalMissed',
  ];
  @Input() filterChangeEvent: EventEmitter<void>;
  additionalFilter: any = {};
  exportColumns: any[] = [];
  selectedExportColumns: any[] = [];
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  dataSource: UsersSummaryDatasource;

  constructor(public reportsService: ReportsService,
              private usersSummaryApiService: UsersReportsApiService,
              public usersSummaryService: UsersSummaryService,
              public dialog: MatDialog,
              public headerService: HeaderService) {
  }

  ngOnInit() {
    if (!this.reportsService.userRights.surveysView) {
      this.displayedColumns = this.displayedColumns.filter(x => x !== 'surveys');
    }

    this.dataSource = new UsersSummaryDatasource(this.usersSummaryApiService);

    this.initEvents();
  }

  initEvents() {
    console.log('init initEvents');
    this.filterChangeEvent.subscribe((filter) => {
      this.additionalFilter = filter;
      this.paginator.pageIndex = 0;
    });

    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
    merge(this.sort.sortChange, this.paginator.page, this.filterChangeEvent)
      .pipe(
        tap(() => this.loadData())
      )
      .subscribe();
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log('ngOnChanges');

    if (changes['filterChangeEvent'] && !changes['filterChangeEvent'].firstChange) {
      this.initEvents();
    }
  }

  getDataFilter(): UsersSummaryFilterRequest {
    const baseRequest: UsersSummaryFilterRequest = {
      skip: this.paginator.pageIndex * this.paginator.pageSize,
      limit: this.paginator.pageSize,
      sort: [{field: this.sort.active, direction: this.sort.direction ? this.sort.direction.toUpperCase() : ''}],
      domain: this.reportsService.selectedDomain || '',
      startDate: '',
      endDate: '',
      extensions: [],
      searchText: '',
      excludeDow: []
    };

    return Object.assign(baseRequest, this.additionalFilter || {});
  }

  loadData() {
    console.log('filter changed');
    this.dataSource.queryData(this.getDataFilter());
  }

  async onExportClick() {
    console.log('exportLogs');
    this.exportColumns = this.usersSummaryService.exportColumns.map((x: any) => {
      return {
        text: x.title,
        value: x.id,
        field: x.field,
        hidden: x.hidden,
        id: x.id
      };
    });

    this.selectedExportColumns = this.exportColumns.filter((item) => {
      return !item.hidden;
    }).map((item) => item.id);

    const dialogRef = this.dialog.open(MatExportDialogComponent, {
      width: '500px',
      height: '60%',
      data: {
        availableColumns: this.exportColumns,
        selectedColumns: this.selectedExportColumns
      }
    });

    dialogRef.afterClosed().subscribe(async (result: any[]) => {
      if (result) {
        this.selectedExportColumns = result;
        await this.onExport();
      }
    });
  }

  async onExport() {
    const exColumns: ExportFieldModel[] = this.usersSummaryService
      .exportColumns
      .filter((x) => {
        return this.selectedExportColumns.indexOf(x.id) > -1;
      });

    await this.usersSummaryService.exportLogs({
      filter: Object.assign({
        domain: this.reportsService.selectedDomain
      }, this.additionalFilter || {}),
      exportFields: exColumns,
    });
  }

  showUserCallLogsDetails(dataItem: UsersSummaryModel) {
    console.log('open call logs dialog');
    this.dialog.open(CallLogsDialogComponent, {
      width: '90%',
      height: '90%',
      data: {
        filter: {
          extensions: [dataItem._id],
          statuses: ['Answered', 'Missed', 'Mailbox'],
          startDate: this.additionalFilter.startDate,
          endDate: this.additionalFilter.endDate,
          domain: this.reportsService.selectedDomain
        }
      }
    });
  }

  ngOnDestroy() {
  }
}
